import { Image } from '@/component/Image';
import { clearHtml } from '@/utils/html';

export const Placement = ({ name, coverImage, description }) => {
  return (
    <section className="container flex max-sm:flex-col max-lg:flex-wrap max-sm:gap-8 sm:gap-16 max-sm:py-8 sm:max-lg:py-[46px] lg:py-16 max-3xl:bg-slate-50 3xl:rounded-10 3xl:mt-3">
      {coverImage?.url && (
        <div className="rounded-10 sm:flex-1 max-sm:h-[288px] sm:h-[360px] overflow-hidden max-sm:w-full sm:max-lg:min-w-[360px] lg:min-w-[416px] lg:max-w-[650px]">
          <Image
            unoptimized
            src={coverImage?.url}
            className="object-cover object-center h-full w-full"
            alt={name}
            loading="lazy"
            width={650}
            height={360}
          />
        </div>
      )}
      <div className="flex flex-col gap-3 flex-1 sm:max-lg:min-w-[360px]">
        <h3 className="text-primary-800 max-sm:text-[24px] sm:text-[32px] leading-[normal] font-semibold tracking-[0.3px]">
          {name}
        </h3>
        <div
          className="text-slate-500 max-sm:text-[16px] max-sm:leading-6 sm:text-lg font-normal sm:leading-7"
          dangerouslySetInnerHTML={{ __html: clearHtml(description) }}
        />
      </div>
    </section>
  );
};
